import getRandomInt from '../functions/getRandomInt';
//import getRandomIntArray from '../functions/getRandomIntArray';
import uqnJoin from '../functions/uqnJoin';
export default function random(type, power) {
    if (typeof type === "undefined" || type == 0) {
        type = getRandomInt(1, 6);
    }
    if (type == 1) { // powers of i: 3 digit
        const n = getRandomInt(0, 99);
        let n1, n2;
        if (n < 10) {
            n1 = 0;
            n2 = n;
        }
        else {
            n1 = Number(n.toString()[0]);
            n2 = Number(n.toString()[1]);
        }
        return uqnJoin([type, n1, n2]);
    }
    else if (type < 4) { // multiply / div: 6 digit
        let a = getRandomInt(0, 9);
        let b = getRandomInt(0, 9);
        if (a == 0 && b == 0) { // avoid z = 0
            a = getRandomInt(1, 9);
        }
        let c = getRandomInt(0, 9);
        let d = getRandomInt(0, 9);
        if (c == 0 && d == 0) { // avoid w = 0
            d = getRandomInt(1, 9);
        }
        if (b == 0 && d == 0) { // avoid non-complex w,z
            d = getRandomInt(1, 9);
        }
        let sign = getRandomInt(0, 9);
        return uqnJoin([type, a, b, c, d, sign]);
    }
    else if (type == 4) { // powers: 5 digit
        let a = getRandomInt(1, 9);
        let b = getRandomInt(1, 9);
        let sign = getRandomInt(0, 3);
        let n;
        if (typeof power == "undefined") {
            n = getRandomInt(2, 3);
        }
        else {
            n = power;
        }
        return uqnJoin([type, a, b, sign, n]);
    }
    else if (type == 5) { // linear equation: 7 digit
        let b = getRandomInt(1, 9);
        let a = getRandomInt(0, 9);
        let c = getRandomInt(0, 9);
        let d = getRandomInt(0, 9);
        if (c == 0 && d == 0) {
            d = getRandomInt(1, 9);
        }
        let e = getRandomInt(0, 9);
        let f = getRandomInt(0, 9);
        if (e == 0 && f == 0) {
            f = getRandomInt(1, 9);
        }
        if (d == 0 && f == 0) {
            d = getRandomInt(1, 9);
        }
        let sign = getRandomInt(0, 9);
        return uqnJoin([b, a, c, d, e, f, sign]);
    }
    else { // quadratic equation: 5 digit
        let a = getRandomInt(1, 9);
        let b = getRandomInt(0, 9);
        let c = getRandomInt(1, 9);
        while (b * b - 4 * a * c >= 0) {
            a = getRandomInt(1, 9);
            b = getRandomInt(1, 9);
            c = getRandomInt(1, 9);
        }
        let sign = getRandomInt(0, 1);
        return uqnJoin([type, a, b, c, sign]);
    }
}
